import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import "../../Styles/yellowcalf.css/Transaction_Failed.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

function Transaction_Failed() {
  const { id } = useParams(); // Get transaction ID from URL
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [transactionData, setTransactionData] = useState(null);
  const [studentInfo, setStudentInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchFailedTransactionDetails();
  }, [id]);

  const fetchFailedTransactionDetails = async () => {
    setIsLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        parent_transactions_id: id  ,
        status:'failed',
        // status: "success",
      };

      const response = await simplePostCall(
        ApiConfig.parentfailedtransactionView,
        JSON.stringify(payload)
      );

      if (response?.result) {
        // Based on your JSON structure: result contains status, model contains student info
        setTransactionData(response.result);
        setStudentInfo(response.model?.[0] || null);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  if (isLoading) {
    return (
     <div className="col-12 text-center p-5">
        <ScaleLoader color="#F4BB44" />
        <p>Loading Transaction Details...</p>
      </div>
    );
  }

  return (
    <div className="tf-panel" style={{ paddingTop: "25px" }}>
      <div className="tf-message-box">
        <h2 className="tf-title">Transaction Failed!</h2>

        <svg
          className="tf-cross-svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 52 52"
          width="100"
          height="100"
        >
          <circle className="tf-cross-circle" cx="26" cy="26" r="25" fill="none"></circle>
          <path className="tf-cross-line" d="M16,16 l20,20"></path>
          <path className="tf-cross-line" d="M16,36 l20,-20"></path>
        </svg>
      </div>

      <table className="tf-table">
        <tbody>
          <tr>
            <td>Response Message</td>
            <td><code>{transactionData?.status || "Payment Failed"}</code></td>
          </tr>
          <tr>
            <td>Transaction Id</td>
            <td><code>{transactionData?.ordernumber || id}</code></td>
          </tr>
          <tr>
            <td>Student Name</td>
            <td><code>{studentInfo?.student_name || "N/A"}</code></td>
          </tr>
          <tr>
            <td>Amount</td>
            <td><code style={{ color: 'red', fontWeight: 'bold' }}>{customer_currency}{transactionData?.amount || "0.00"}</code></td>
          </tr>
          <tr>
            <td>Payment Option</td>
            <td style={{ textTransform: 'capitalize' }}><code>{transactionData?.gateway_name || "N/A"}</code></td>
          </tr>
          <tr>
            <td>Failure Reason</td>
            <td><code>{transactionData?.reason || "Technical Error / Timeout"}</code></td>
          </tr>
        </tbody>
      </table>

      {/* <div className="tf-btn-container">
        <button className="tf-print-btn" onClick={handlePrint}>Print Receipt</button>
      </div> */}
    </div>
  );
}

export default Transaction_Failed;